import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPlacements } from 'core/actions/ocapi';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import MarketingMotto from 'core/modules/Partials/MarketingMotto/MarketingMotto';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import List from 'core/modules/Partials/List/List';

import {
  selectTrendingAndSeasonalOffersConfig,
  selectTrendingAndSeasonalOffersIsLoading,
  selectTrendingAndSeasonalOffersIsLoaded,
  selectTrendingAndSeasonalOffersData,
} from './selectors';

import TrendingAndSeasonalOffer from './components/TrendingAndSeasonalOffer';

import { triggerTrendingAndSeasonalOffersIsViewed } from './actions';

import './TrendingAndSeasonalOffers.scss';

function TrendingAndSeasonalOffers() {
  const config = useSelector(selectTrendingAndSeasonalOffersConfig);
  const isLoading = useSelector(selectTrendingAndSeasonalOffersIsLoading);
  const isLoaded = useSelector(selectTrendingAndSeasonalOffersIsLoaded);
  const offers = useSelector(selectTrendingAndSeasonalOffersData);
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const {
    api: { params, options }, getTitle, getMotto, contentWrap,
  } = config;
  const { content_group_id: contentGroupId } = params;
  const dispatch = useDispatch();
  const title = getTitle(isMobileMQ);
  const motto = getMotto();

  useEffect(() => {
    if (!isLoaded && !isLoading) {
      dispatch(fetchPlacements(params, options));
    }
  }, []);

  useEffect(() => {
    if (isLoaded && offers.length) {
      offers.forEach((offer) => {
        dispatch(triggerTrendingAndSeasonalOffersIsViewed(offer, contentGroupId));
      });
    }
  }, [isLoaded, offers.length]);

  if (offers.length === 0) {
    return null;
  }

  return (
    <div className="mn_trendingAndSeasonalOffers">
      <ContentWrap {...contentWrap}>
        <MarketingMotto motto={motto} />
        <SectionTitle title={title} />
        <List>
          {offers.map((offer, index) => (<TrendingAndSeasonalOffer key={offer.id} {...offer} position={index} />))}
        </List>
      </ContentWrap>
    </div>
  );
}

export default (props) =>
  <ComponentErrorBoundary><TrendingAndSeasonalOffers {...props} /></ComponentErrorBoundary>;
